/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

module.exports = require('react/lib/ReactDOM');




/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dom/index.js
 ** module id = 13
 ** module chunks = 0
 **/